/**
 * Password Validation Logic
 * Provides cryptographic strength assessment and real-time rule tracking.
 */

export const REGEX = {
  EMAIL: /^[A-Z\d._%+-]+@[A-Z\d.-]+\.[A-Z]{2,}$/i,
  NAME: /^[A-Za-z ]+$/,
  ORG: /^[A-Za-z0-9_ ]+$/,
  MOBILE: /^\d+$/,
  CAPITAL: /[A-Z]/,
  LOWERCASE: /[a-z]/,
  NUMBER: /\d/,
  SPECIAL: /[^A-Za-z0-9]/,
};

export type PasswordRuleKey =
  | 'length'
  | 'capital'
  | 'lowercase'
  | 'number'
  | 'special';

export type PasswordRulesResult = Record<PasswordRuleKey, boolean>;

export const checkPasswordRules = (pwd: string) => ({
  length: pwd.length >= 8 && pwd.length <= 60,
  capital: REGEX.CAPITAL.test(pwd),
  lowercase: REGEX.LOWERCASE.test(pwd),
  number: REGEX.NUMBER.test(pwd),
  special: REGEX.SPECIAL.test(pwd),
});

export const isPasswordStrong = (pwd: string) =>
  Object.values(checkPasswordRules(pwd)).every(Boolean);

export const PASSWORD_RULE_LABELS: { key: PasswordRuleKey; label: string }[] = [
  { key: 'length', label: 'At least 8 characters' },
  { key: 'capital', label: 'One uppercase letter' },
  { key: 'lowercase', label: 'One lowercase letter' },
  { key: 'number', label: 'One number' },
  { key: 'special', label: 'One special character' },
];
